import * as etree from 'elementtree';

/**
 * @param {any} template
 * @param {any} cellCount is obj {cell, count} or Array of objects
 */
export const mergeCellsRight = (template, cellCount) => {
    if (!Array.isArray(cellCount))
        cellCount = [cellCount];
    const sheet = template.loadSheet(1);
    const mc = sheet.root.find('./mergeCells');
    cellCount.filter(o => o.count > 0).forEach(({ cell, count }) => {
        let mcell = mc.getchildren().find(m => m.attrib.ref.split(':')[0] == cell);
        const [start, end] = mcell ? mcell.attrib.ref.split(':') : [cell, cell];
        if (!mcell)
            mcell = etree.SubElement(mc, 'mergeCell');
        const [col, row] = end.match(/^([^\d]+)(\d+)$/).slice(1);
        const newCol = template.numToChar(template.charToNum(col) + count);
        mcell.set('ref', `${start}:${newCol}${row}`);
    });
    template.archive.file(sheet.filename, etree.tostring(sheet.root));
}